import Auth from './auth'
import Tag from './tag'
import ENUM from '../assets/ENUM'

import Store from '@/store'

export default {

    connect: async (vue, email, password, provider) => {
        const now = (new Date()).getTime()
        // Avoid several calls in a short period of time
        if (!lastCallDone || (lastCallDone + 5000) < now) {
            lastCallDone = now
            const response = await Auth.connect(vue, email, password, provider, {})
            postConnectRouteResponse(vue, provider, response)
        }
    },

    postConnectRoute: (vue, provider, response) => {
        postConnectRouteResponse(vue, provider, response)
    }
}

// Private

let lastCallDone = undefined

function postConnectRouteResponse(vue, provider, response) {
    Tag.infoAll(vue, 'status_final_connection', provider, Auth.Statuses.SUCCESS)
    if (response.status === ENUM.LOGIN_STATUS.CREATED) {
        vue.routerPush('/fetch')
    } else if (Store.getters.emailToDeleteRedirect) {
        vue.routerPush('/settings')
    } else {
        vue.routerPush('/newsletters')
    }
}
